/*
 * jQuery Minimun Password Requirements 1.1
 * http://elationbase.com
 * Copyright 2014, elationbase
 * Check Minimun Password Requirements
 * Free to use under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 */


(function ($) {
  $.fn.extend({
    passwordRequirements(options) {
      // options for the plugin
      const defaults = {
        numCharacters: 8,
        useLowercase: true,
        useUppercase: true,
        useNumbers: true,
        useSpecial: true,
        infoMessage: '',
        style: 'light', // Style Options light or dark
        fadeTime: 300 // FadeIn / FadeOut in milliseconds
      };

      options = $.extend(defaults, options);

      return this.each(function () {
        const o = options;

        o.infoMessage = '';
        // Add Variables for the li elements
        const numCharactersUI = '';
        let useLowercaseUI = '';
        let useUppercaseUI = '';
        let useNumbersUI = '';
        let useSpecialUI = '';
        // Check if the options are checked
        if (o.useSpecial === true) {
          useSpecialUI = `<li class="pr-useSpecial"><span></span>${__('be at least 8 characters')}</li>`;
        }
        if (o.useLowercase === true) {
          useLowercaseUI = `<li class="pr-useLowercase"><span></span>${__('contain  at least one lowercase letter [a - z]')}</li>`;
        }
        if (o.useUppercase === true) {
          useUppercaseUI = `<li class="pr-useUppercase"><span></span>${__('contain  at least one uppercase letter [A - Z]')}</li>`;
        }
        if (o.useNumbers === true) {
          useNumbersUI = `<li class="pr-useNumbers"><span></span>${__('contain  at least one number [0 - 9]')}</li>`;
        }


        // Append password hint div
        const messageDiv = `<div id="pr-box" class="light"><i></i><div id="pr-box-inner"><ul>${numCharactersUI}${useLowercaseUI}${useUppercaseUI}${useNumbersUI}${useSpecialUI}</ul></div></div>`;
        $('body form.form-login > .form-group:nth-child(2)').append(messageDiv);
        // Set campletion vatiables
        let numCharactersDone = true;
        let useLowercaseDone = true;
        let useUppercaseDone = true;
        let useNumbersDone = true;
        let useSpecialDone = true;

        // Show Message reusable function
        const showMessage = function () {
          if (numCharactersDone === false || useLowercaseDone === false || useUppercaseDone === false || useNumbersDone === false || useSpecialDone === false) {
            $('.pr-password').each(() => {
              // Append info box tho the body
              if ($('body form.form-login > .form-group:nth-child(2) #pr-box').length) {
                $('body form.form-login > .form-group:nth-child(2) #pr-box').remove();
              }
              $('body form.form-login > .form-group:nth-child(2)').append(messageDiv);
              $('#pr-box').addClass(o.style)
                  .fadeIn(o.fadeTime);
            });
          }
        };

        // Show password hint
        showMessage();


        // Delete Message reusable function
        const deleteMessage = function () {
          const targetMessage = $('#pr-box');
        };

        // Show / Delete Message when completed requirements function
        const checkCompleted = function () {
          if (numCharactersDone === true && useLowercaseDone === true && useUppercaseDone === true && useNumbersDone === true && useSpecialDone === true) {
            deleteMessage();
          } else {
            showMessage();
          }
        };

        // Show password hint
        $(this).on('blur', () => {
          deleteMessage();
        });


        // Show or Hide password hint based on user's event
        // Set variables
        const lowerCase = new RegExp('[a-z]');
        const upperCase = new RegExp('[A-Z]');
        const numbers = new RegExp('[0-9]');
        const specialCharacter = new RegExp('[0-9a-zA-Z]{8,}');

        // Show or Hide password hint based on keyup
        $(this).on('keyup focus', function () {
          const thisVal = $(this).val();

          checkCompleted();

          // Check # of characters
          if (thisVal.length >= o.numCharacters) {
            // console.log("good numCharacters");
            $('.pr-numCharacters span').addClass('pr-ok');
            numCharactersDone = true;
          } else {
            // console.log("bad numCharacters");
            $('.pr-numCharacters span').removeClass('pr-ok');
            numCharactersDone = false;
          }
          // lowerCase meet requirements
          if (o.useLowercase === true) {
            if (thisVal.match(lowerCase)) {
              // console.log("good lowerCase");
              $('.pr-useLowercase span').addClass('pr-ok');
              useLowercaseDone = true;
            } else {
              // console.log("bad lowerCase");
              $('.pr-useLowercase span').removeClass('pr-ok');
              useLowercaseDone = false;
            }
          }
          // upperCase meet requirements
          if (o.useUppercase === true) {
            if (thisVal.match(upperCase)) {
              // console.log("good upperCase");
              $('.pr-useUppercase span').addClass('pr-ok');
              useUppercaseDone = true;
            } else {
              // console.log("bad upperCase");
              $('.pr-useUppercase span').removeClass('pr-ok');
              useUppercaseDone = false;
            }
          }
          // upperCase meet requirements
          if (o.useNumbers === true) {
            if (thisVal.match(numbers)) {
              // console.log("good numbers");
              $('.pr-useNumbers span').addClass('pr-ok');
              useNumbersDone = true;
            } else {
              // console.log("bad numbers");
              $('.pr-useNumbers span').removeClass('pr-ok');
              useNumbersDone = false;
            }
          }
          // upperCase meet requirements
          if (o.useSpecial === true) {
            if (thisVal.length > 7) {
              $('.pr-useSpecial span').addClass('pr-ok');
              useSpecialDone = true;
            } else {
              $('.pr-useSpecial span').removeClass('pr-ok');
              useSpecialDone = false;
            }
          }
        });
      });
    }
  });
}(jQuery));
